const mainURL = 'https://amc-api.americasrf.com/api/';

export default mainURL;
